import React from 'react'
import styled from 'styled-components'

import findByLayoutId from '../../utils/findByLayoutId.js'

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`

const Main = styled.div`
  height: 100%;
  position: relative;
`

export default function MapOnlyLayout ({ app, children }) {
  const map = findByLayoutId('map', children, app)
  const appInfo = findByLayoutId('appInfo', children, app)
  return <Wrapper>
    <Main>{map}{appInfo}</Main>
  </Wrapper>
}
